import React from 'react';
import { Table } from '@gerdau/hefesto-mais-web';
import { TableContainer } from './styles';
import { useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import { Link } from '@gerdau/hefesto';
import { useHistory } from 'react-router-dom';
import { ERoutes } from '../../../../../routes';

const TableCoins: React.FC = () => {
  const loyalty = useSelector((appState: ApplicationState) => appState.loyalty);
  const user = useSelector((state: ApplicationState) => state.user);
  const history = useHistory();

  const baseHistory = loyalty.history.history_body.map((item) => {
    const parsedDate = item.order_date;
    const monthInitials = new Date(item.order_date).toLocaleDateString();
    const orderTotal = 'R$ ' + item.order_total.toLocaleString('pt-BR');
    return {
      date: monthInitials,
      order: parsedDate,
      order_id: item.order_id,
      order_total: orderTotal
    };
  });

  const tableDataSource = baseHistory.map((item, key) => {
    return {
      key: key,
      data: item?.date,
      pedido: item?.order_id,
      valor: item?.order_total,
      detalhes: user.userPermissions.hasOrderViewAccess ? (
        <Link
          name="Ver pedido"
          url="/#"
          onClick={() => history.push(`${ERoutes.ORDERS}`)}
        />
      ) : (
        'Visualização não disponível'
      )
    };
  });

  const tableColumns = [
    {
      dataIndex: 'data',
      key: 'data',
      title: 'Data'
    },
    {
      dataIndex: 'pedido',
      key: 'pedido',
      title: 'Pedido'
    },
    {
      dataIndex: 'valor',
      key: 'valor',
      title: 'Valor'
    },
    {
      dataIndex: 'detalhes',
      key: 'detalhes',
      title: 'Detalhes'
    }
  ];
  return (
    <TableContainer>
      <Table columns={tableColumns} dataSource={tableDataSource}></Table>
    </TableContainer>
  );
};

export default TableCoins;
